import PropTypes from 'prop-types';
import * as AuthStates from './AuthStates';

export const session = PropTypes.object.isRequired;
export const state = PropTypes.oneOf(AuthStates.All);
export const user = PropTypes.object.isRequired;
export const actions = PropTypes.shape({
  signIn: PropTypes.func.isRequired,
  signOut: PropTypes.func.isRequired
}).isRequired;
